import { baseUrl } from "../actions";
import axiosInstance from '../helpers/axiosInstance';

export const loginApi = async (request) => {
    try {
        const LOGIN_API_ENDPOINT = `${baseUrl}public/internalUserLogin`;
        const response = await axiosInstance.post(LOGIN_API_ENDPOINT, request.formData);
        return response.data;
    } catch (error) {
        console.error('Login API Error:', error);
        throw error;
    }
};

export const forgotPasswordApi = async (request) => {
    try {
        const FORGOT_PASSWORD_API_ENDPOINT = `${baseUrl}public/forgotPassword`;
        const response = await axiosInstance.post(FORGOT_PASSWORD_API_ENDPOINT, request.formData);
        return response.data;
    } catch (error) {
        console.error('Forgot Password API Error:', error);
        throw error;
    }
};






